export const SubHead = ({text, isReport}) => {
    if (isReport) {
        return <h3>{text}</h3>
    }
    return <h3 className="subhead">{text}</h3>
}